import { render, staticRenderFns } from "./SpacerSpecial.vue?vue&type=template&id=e68fad98&scoped=true"
import script from "./SpacerSpecial.vue?vue&type=script&lang=js"
export * from "./SpacerSpecial.vue?vue&type=script&lang=js"
import style0 from "./SpacerSpecial.vue?vue&type=style&index=0&id=e68fad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68fad98",
  null
  
)

export default component.exports